import { navigateWithinForum } from '../../../../common/actions/navigate-within-forum';

export const discardPostModalResolver = ({ categorySlug, postSlug }) => dispatch => {
  return dispatch(
    navigateWithinForum(categorySlug ? `/${categorySlug}${postSlug ? `/${postSlug}` : ''}` : '/'),
  );
};
